export default function BrandLogo({
  className = "",
  label = "Corte Gesya — Vivere oltre gli spazi",
  decorative = false,
}) {
  const classes = ["brand-logo", className].filter(Boolean).join(" ");

  return (
    <span
      className={classes}
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
    >
      <img
        className="brand-logo__symbol"
        src="/corte-gesya-symbol-clean-v5.png"
        alt=""
      />
      <img
        className="brand-logo__wordmark"
        src="/corte-gesya-lettermark-510001-v5.svg"
        alt=""
      />
    </span>
  );
}
